class TC_PlayerCover {
    constructor (playerInstance) {
        this.player = playerInstance;
        this.isSafariDesktop = window.safari !== undefined;
        this.timeoutTimer = false;
    }

    getCurrentChannelData () {
        let timeoutTime = 3500;
        let timestampParam = '';

        if (this.isSafariDesktop) {
            timeoutTime = 7000;
            timestampParam = '?v=' + Math.round(+Date.now() / 7500);
        }

        if (this.player.currentChannelHasChapters()) {
            timeoutTime = 1000;
        }

        if (!this.player.currentChannelHasChapters()) {
            $.ajax({
                url: this.player.currentChannel.url + timestampParam,
                type: 'GET',
                dataType: 'JSON',
                xhrFields: {
                    withCredentials: true
                },
                success: (data, status, xhr) => {                
                    if (status === 'success' && data && data.now_playing) {
                        if (
                            data.now_playing.album !== this.player.currentChannel.album ||
                            data.now_playing.title !== this.player.currentChannel.title ||
                            data.now_playing.id !== this.player.currentTrackID
                        ) {
                            this.player.currentChannel.album = data.now_playing.album;
                            this.player.currentChannel.artist = data.now_playing.artist;
                            this.player.currentChannel.title = data.now_playing.title;
                            this.player.currentTrackID = data.now_playing.id;
                            this.updateChannelInfo();
                        }
        
                        if (this.player.artsUrl + data.now_playing.album_art !== this.player.currentChannel.cover) {
                            this.updateChannelCover(this.player.artsUrl + data.now_playing.album_art);
                        }
                    }
                }
            });
        } else {
            let cacheData = this.player.timetableCache.getTimetable(this.player.currentChannel.streamID);

            if (cacheData === false) {
                this.getChaptersData(this.player.currentChannel.streamID, timestampParam);
            } else {
                this.checkIfStoryIsFinished();
                this.updateChapterData(cacheData);
            }
        }

        clearTimeout(this.timeoutTimer);

        this.timeoutTimer = setTimeout(() => {
            this.getCurrentChannelData();
            $(document).trigger('seekingBarUpdate');
        }, timeoutTime);
    }

    fastUpdateChapterData () {
        let cacheData = this.player.timetableCache.getTimetable(this.player.currentChannel.streamID, false);
        this.updateChapterData(cacheData);
    }

    updateChannelInfo () {
        this.player.UI.album.info.channelName.text(this.player.currentChannel.channelName);
        this.player.UI.album.info.title.text(this.player.currentChannel.title);
        this.getTrackOpinion();
    }

    updateChannelCover (newCover) {
        this.player.currentChannel.cover = newCover;
        this.player.UI.album.coverReplacement.one('load', () => {
            if (this.player.UI.album.loader) {
                this.player.UI.album.loader.remove();
                this.player.UI.album.loader = false;
            }

            this.player.UI.album.coverReplacement.removeClass('is-hidden');

            setTimeout(() => {
                this.player.UI.album.cover.attr('src', this.player.currentChannel.cover);
                this.player.UI.album.coverReplacement.addClass('is-hidden');
            }, 600);
        });

        this.player.UI.album.coverReplacement.attr('src', this.player.currentChannel.cover);
    }

    getTrackOpinion () {
        let url =
        `https://api.${window.CSITE.appDomain}/opinions/tracks/${this.player.currentTrackID}?username=${this.player.user.login}&token=${this.player.user.token}`;
        this.player.UI.album.like.removeClass('is-liked');
        this.player.UI.album.dislike.removeClass('is-disliked');

        $.get(url, (data, status) => {
            if (status === 'success') {
                if (data.opinion === 1) {
                    this.player.UI.album.like.addClass('is-liked');
                    this.player.UI.album.dislike.removeClass('is-disliked');
                } else if (data.opinion === -1) {
                    this.player.UI.album.dislike.addClass('is-disliked');
                    this.player.UI.album.like.removeClass('is-liked');
                }
            }
        });
    }

    likeTrack () {
        let url =
        `https://api.${window.CSITE.appDomain}/opinions/tracks/${this.player.currentTrackID}/like?username=${this.player.user.login}&token=${this.player.user.token}`;
        this.player.UI.album.like.css('opacity', .25);
        this.player.UI.album.like.css('pointer-events', 'none');

        $.get(url, (data, status) => {
            if (status === 'success') {
                this.player.UI.album.like.addClass('is-liked');
                this.player.UI.album.dislike.removeClass('is-disliked');
                this.player.UI.album.like.css('opacity', '');
                this.player.UI.album.like.css('pointer-events', 'auto');
            }
        });
    }

    dislikeTrack () {
        let url = `https://api.${window.CSITE.appDomain}/opinions/tracks/${this.player.currentTrackID}/dislike?username=${this.player.user.login}&token=${this.player.user.token}`;
        this.player.UI.album.dislike.css('opacity', .25);
        this.player.UI.album.dislike.css('pointer-events', 'none');

        $.get(url, (data, status) => {
            if (status === 'success') {
                this.player.UI.album.dislike.addClass('is-disliked');
                this.player.UI.album.like.removeClass('is-liked');
                this.player.UI.album.dislike.css('opacity', '');
                this.player.UI.album.dislike.css('pointer-events', 'auto');
            }
        });
    }

    getChaptersData (streamID, timestampParam) {
        $.ajax({
            url: this.player.currentChannel.url + timestampParam,
            type: 'GET',
            dataType: 'JSON',
            xhrFields: {
                withCredentials: true
            },
            success: (data, status, xhr) => {                
                if (status === 'success' && data && data.tracks) {
                    this.updateChapterData(data);
                    this.player.timetableCache.saveTimetable(streamID, data);
                }
            }
        });
    }

    updateChapterData (data) {
        let trackID = this.player.detectChapter(data);
        let trackData = this.getChapterTrackData(data, trackID);
        let currentChapterNumber = this.player.detectChapterIndex(data) + 1;
        let previousChapterNumber = this.player.currentChannel.currentChapter;

        if (currentChapterNumber !== previousChapterNumber) {
            this.player.currentChannel.currentChapter = currentChapterNumber;
            this.player.debouncedSaveLastListenedChapter();

            if (this.player.checkIfChapterIsLast(trackID, data)) {
                this.player.UI.buttons.switchNext.addClass('is-inactive');
            } else {
                this.player.UI.buttons.switchNext.removeClass('is-inactive');
            }
        }

        if (
            trackData.album !== this.player.currentChannel.album ||
            trackData.title !== this.player.currentChannel.title ||
            trackData.trackID !== this.player.currentTrackID
        ) {
            this.player.currentChannel.album = trackData.album;
            this.player.currentChannel.artist = trackData.artist;
            this.player.currentChannel.title = trackData.title;
            this.player.currentTrackID = trackData.trackID;
            this.updateChannelInfo();
        }

        if (trackData.cover !== this.player.currentChannel.cover) {
            this.updateChannelCover(trackData.cover);
        }
    }

    getChapterTrackData (chaptersData, trackID) {
        let metadata = chaptersData.metadata[trackID];

        return {
            album: metadata.album,
            artist: metadata.artist,
            title: metadata.title,
            cover: this.player.artsUrl + metadata.art,
            trackID: trackID
        };
    }

    checkIfStoryIsFinished () {
        let currentTime = this.player.audioChannels['channel1'].element.currentTime;
        let duration = this.player.audioChannels['channel1'].element.duration;
        let currentChannelID = this.player.currentChannel.id;
        
        if (currentTime >= duration && this.player.remoteData.finishedStories.indexOf(currentChannelID) === -1) {
            this.player.remoteData.finishedStories.push(currentChannelID);

            $.post('https://api.' + window.CSITE.appDomain + '/v2/story', JSON.stringify({
                username: this.player.user.login,
                token: this.player.user.token,
                channel_id: parseInt(this.player.currentChannel.id, 10)
            })).done(() => {
                this.player.currentChannel.currentChapter = 1;
                this.player.pauseEventToSkip = true;
                this.player.audioChannels['channel1'].element.pause();
                this.player.audioChannels['channel1'].element.currentTime = 0;
                this.player.UI.buttons.playIconPause.addClass('is-hidden');
                this.player.UI.buttons.playIconPlay.removeClass('is-hidden');
                this.player.playing = false;
                $(document).trigger('playingStateChanged', [this.playing]);
                this.player.debouncedSaveLastListenedChapter();
            });
        } else if (currentTime >= duration && this.player.remoteData.finishedStories.indexOf(currentChannelID) > -1) {
            this.player.currentChannel.currentChapter = 1;
            this.player.pauseEventToSkip = true;
            this.player.audioChannels['channel1'].element.pause();
            this.player.audioChannels['channel1'].element.currentTime = 0;
            this.player.UI.buttons.playIconPause.addClass('is-hidden');
            this.player.UI.buttons.playIconPlay.removeClass('is-hidden');
            this.player.playing = false;
            $(document).trigger('playingStateChanged', [this.playing]);
            this.player.debouncedSaveLastListenedChapter();
        }
    }
}
